export const GET_QUOTE_APPLICATION_DATA_START = 'GET_QUOTE_APPLICATION_DATA_START';
export const GET_QUOTE_APPLICATION_DATA_SUCCESS = 'GET_QUOTE_APPLICATION_DATA_SUCCESS';
export const GET_QUOTE_APPLICATION_DATA_FAIL = 'GET_QUOTE_APPLICATION_DATA_FAIL';

export const SAVE_BOLD_PENGUIN_APPLICATION_ID_START = 'SAVE_BOLD_PENGUIN_APPLICATION_ID_START';
export const SAVE_BOLD_PENGUIN_APPLICATION_ID_SUCCESS = 'SAVE_BOLD_PENGUIN_APPLICATION_ID_SUCCESS';
export const SAVE_BOLD_PENGUIN_APPLICATION_ID_FAIL = 'SAVE_BOLD_PENGUIN_APPLICATION_ID_FAIL';
